/* CASEONL 2.0 — interaction layer (no dependencies)
   - scroll reveal (IntersectionObserver)
   - 3D tilt cards (pointer-driven, rAF-throttled)
   - sticky add-to-cart bar on product pages
   Respects prefers-reduced-motion throughout. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cx-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cx-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cx-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3D tilt ---------- */
  function initTilt() {
    if (reduced || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.cx-tilt').forEach(function (card) {
      var max = parseFloat(card.dataset.cxTiltMax || '7');
      var raf = null;

      function onMove(e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.classList.add('cx-tilting');
          card.style.transform =
            'rotateX(' + (-py * max).toFixed(2) + 'deg) rotateY(' + (px * max).toFixed(2) + 'deg) translateZ(0)';
        });
      }
      function onLeave() {
        if (raf) cancelAnimationFrame(raf);
        card.classList.remove('cx-tilting');
        card.style.transform = '';
      }
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', onLeave);
    });
  }

  /* ---------- sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-cx-satc]');
    if (!bar) return;
    var anchor = document.querySelector('.product-form__submit, product-form [type="submit"]');
    if (!anchor) return;

    var shown = false;
    function toggle(show) {
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('cx-satc--show', show);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        toggle(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(anchor);
    }

    var btn = bar.querySelector('[data-cx-satc-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        anchor.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        // give the browser a beat to scroll, then trigger the real ATC
        setTimeout(function () { anchor.click(); }, reduced ? 0 : 450);
      });
    }
  }

  function boot() {
    initReveal();
    initTilt();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
